export class Bootstrap {
	
	static init(){
		Bootstrap.update();
		Bootstrap.initMedia();
		window.addEventListener('resize',Bootstrap.update);
	}
	
	static update(e){
		Bootstrap.initTouch();
		Bootstrap.initMedia();
	}
	
	static initTouch(){
		if(Bootstrap.isTouch()){
			document.body.classList.add('is-touch');
			document.body.classList.remove('is-not-touch');
		}else{
			document.body.classList.remove('is-touch');
			document.body.classList.add('is-not-touch');
		}
	}
	
		
	static isTouch(){
		var touch = 'ontouchstart' in document.documentElement
			|| navigator.maxTouchPoints > 0
			|| navigator.msMaxTouchPoints > 0;
		return touch;
	}
	
	static initMedia() {
		if (Bootstrap.isSmartPhone()) {
			document.body.classList.add('is-sp');
		} else {
			document.body.classList.remove('is-sp');
		}
	}
	
	// mediaMatch関数でスマホを判定
	static isSmartPhone() {
		if (window.matchMedia('(max-width: 768px)').matches) {
			return true;
		} else {
			return false;
		}
	}
	
	static loadLazyImages () {
		document.querySelectorAll('img[loading="lazy"]').forEach((el) => {
			el.setAttribute('loading', 'eager');
		});
	}
	
}